import React, { Component, Fragment } from "react";
import NavBarComponent from "../../utilerias/nav";
import MenuComponent from "../../utilerias/menu";
import GaleriaBannerComponent from "../componentes/galeria";
import RedesComponent from "../../utilerias/redesSociales";
import ReactGA from "react-ga";
import "./styles.css";

export class GaleriaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guardarNuevoIdioma: true,
      idiomaNavegador: navigator.language || navigator.userLanguage,
      componente: "",
      statusMenu: false,
    };
  }

  UNSAFE_componentWillMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        this.setState({ componente: "jack in action" });
        this.setState({ guardarNuevoIdioma: false });
      } else {
        this.setState({ componente: "jack en acción" });
        this.setState({ guardarNuevoIdioma: true });
      }
    } else {
      if (storage !== null && storage === false) {
        this.setState({ componente: "jack en acción" });
        this.setState({ guardarNuevoIdioma: true });
      } else {
        this.setState({ componente: "jack in action" });
        this.setState({ guardarNuevoIdioma: false });
      }
    }
  }
  componentDidMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    } else {
      if (storage !== null && storage === false) {
        document.getElementById("text-lang").innerHTML = "ESP";
      } else {
        document.getElementById("text-lang").innerHTML = "ENG";
      }
    }
  }
  render() {

    const openNav = () => {
      ReactGA.event({
        category: "Button",
        action: "Se ha dado click en el apartado del nav",
      });
      this.setState({ statusMenu: true });
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        document.getElementById("myNav").style.height = "110%";
      } else {
        document.getElementById("myNav").style.height = "100%";
      }
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
      document.getElementById("myNav").style.overflowY = "auto";
    };

    const closeNav = () => {
      this.setState({ statusMenu: false });
      document.getElementsByTagName("html")[0].style.overflowY = "visible";
      document.getElementById("myNav").style.height = "0%";
    };

    const cambiarIdioma = () => {
      if (this.state.guardarNuevoIdioma) {
        this.setState({ guardarNuevoIdioma: false });
        this.setState({ componente: "jack in action" });
        document.getElementById("text-lang").innerHTML = "ENG";
        localStorage.setItem("español", true);
      } else {
        this.setState({ guardarNuevoIdioma: true });
        this.setState({ componente: "jack en acción" });
        document.getElementById("text-lang").innerHTML = "ESP";
        localStorage.setItem("español", false);
      }
    };
    return (
      <Fragment>
        <div className="galeria-fondo">
          <NavBarComponent
            closeNav={closeNav}
            openNav={openNav}
            statusMenu={this.state.statusMenu}
            cambiarIdioma={cambiarIdioma}></NavBarComponent>
          <MenuComponent
            closeNav={closeNav}
            cambiarIdioma={this.state.guardarNuevoIdioma}
          ></MenuComponent>
          <GaleriaBannerComponent
            componente={this.state.componente}
          ></GaleriaBannerComponent>
          <RedesComponent></RedesComponent>
        </div>
      </Fragment>
    );
  }
}

export default GaleriaComponent;
